// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header[data-v-c7e4a15a]{padding:30px 40px}header .wrapper-controls[data-v-c7e4a15a]{display:flex;justify-content:flex-end;align-items:center}header .user-panel[data-v-c7e4a15a]{margin-left:10px}@media only screen and (max-width:991px){header .header-logo .logo[data-v-c7e4a15a],header .wrapper-controls[data-v-c7e4a15a]{display:none}}@media only screen and (max-width:485px){.main-page header[data-v-c7e4a15a]{padding:20px 10px}}", ""]);
// Exports
module.exports = exports;
